<!-- Добавить подсказку: double click on species name to expand data about species . Добавить кнопку ведущую на страницу "о чеклисте"-->
<template>
    <v-app theme="mainCustomLightTheme">
      <cyano-header></cyano-header>
      
      <div class="px-lg-3">
        <div class="text-h4 px-lg-1 px-1">
          Cyanoprokaryota checklist of the Murmansk region
        </div>

<div class="text-h6 px-lg-1 px-1">

<!--link to about  and blah blah blah-->

  <base-checklist
    :dataset_uri="this.$store.state.mainurl+'/dataset/list?f='+262" 
    :tablestructur="this.$store.state.mainurl+'/dataset/list?f=100&f_id='+262"
    :spcffieldname="'ref_cfsspslfvsp_lnvl'"
    :spcffieldvalue="1"
    :mgroup="'ref_mgroup_7td9'"
    :mgroupvalue="1817"
    :areacoordvalue="'geotable:2171:4:geom'"
    :idtable="262"

  ></base-checklist>
</div>


</div>


          <base-footer></base-footer>
          </v-app>
          </template>
  
  <script>
  import { defineComponent } from 'vue';
  import CyanoHeader from './CyanoHeader.vue';
  import BaseChecklist from '@/components/BaseChecklist.vue';
  
  
  export default defineComponent({
    name: 'MossCheklistMurmansk',
  
    components: {
BaseChecklist,
CyanoHeader,
    },
    data: () => ({
      clicktooltip: 'Click to copy',
      }),
      methods: {
          clicktooltipMessage(){
            if (this.clicktooltip =='Click to copy') {
            this.clicktooltip = 'Copied';
            }
            else {
              this.clicktooltip = 'Click to copy';
            }
            setTimeout(() => {
          this.clicktooltip = 'Click to copy';
        }, 10000);
  
          },
  
      },
        
  });
  </script>
  